/**
 * Store Use Cases Factory
 *
 * @module @personnel/composition/factories/createStoreUseCases
 */

import type { AxiosInstance } from 'axios';
import type { StoreUseCases } from '@personnel/composition/types';

import { createStoreApiRepository } from '@personnel/infrastructure/repositories/StoreApiRepository';
import { getStoresUseCase } from '@personnel/application/use-cases/GetStoresUseCase';

/**
 * Assembles all store use cases with their injected dependencies.
 *
 * @param httpClient - Axios instance for the connect API
 * @returns Fully composed store use cases
 */
export const createStoreUseCases = (httpClient: AxiosInstance): StoreUseCases => {
  const apiPort = createStoreApiRepository({ httpClient });

  return {
    getStores: getStoresUseCase({ apiPort }),
  };
};
